import { API } from 'src/api';

export const notifyUsers = async (
  url: string,
  fileId: string,
  id: string,
  members: string[],
  message: string,
  name: string
) => {
  try {
    const response = await API.post(`/whiteboard/mention`, {
      url,
      file: fileId,
      id,
      members,
      message,
      name,
    });
    return response.data;
  } catch (error) {
    console.error('error', error);
    return null;
  }
};
